import * as React from 'react';

const useDomRefById = (id: string): React.RefObject<HTMLElement> => {
  const portalRef = React.useRef<HTMLElement | null>(null);
  React.useEffect(() => {
    const portal = document.getElementById(id);
    if (portal) {
      portalRef.current = portal;
    }
  });
  return portalRef;
};

export default useDomRefById;
